import { forwardRef, useEffect, useState } from 'react'

import {
    Radio,
    RadioGroup,
    Grid,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    Input,
    TextField,
    Slide
} from '@mui/material';
import useHistorialClinico from '../../../hooks/useHistorialClinico';


const Patologicos = () => {

    const { datosMedico, handleChangeClinico, handleChangeClinicoMed, dataAvance} = useHistorialClinico()
    const { comentariosPatologicos } = datosMedico
    const { antPatologicos } = dataAvance

    //Primera parte
    const [alergias, setAlergias] = useState(dataAvance.antPatologicos.antpaAlergiasPa==="Si"?true:false);
    const [asm, setAsm] = useState(dataAvance.antPatologicos.antpaAsmaPa==="Si"?true:false);
    const [can, setCan] = useState(dataAvance.antPatologicos.antpaCancerPa==="Si"?true:false);
    const [cirugias, setCirugias] = useState(dataAvance.antPatologicos.antpaCirugiasPa==="Si"?true:false)
    const [conv, setConv] = useState(dataAvance.antPatologicos.antpaConvulsionesPa==="Si"?true:false);
    const [desmayos, setDesmayos] = useState(dataAvance.antPatologicos.antpaDesmayosPa==="Si"?true:false);
    const [diab, setDiab] = useState(dataAvance.antPatologicos.antpaDiabetesPa==="Si"?true:false);
    const [dolores, setDolores] = useState(dataAvance.antPatologicos.antpaDolorEspaldaCuelloPa==="Si"?true:false);
    const [comunicacion, setComunicacion] = useState(dataAvance.antPatologicos.antpaLimitacionOralEscritaPa==="Si"?true:false);
    const [vision, setVision] = useState(dataAvance.antPatologicos.antpaDisminucionVisualPa==="Si"?true:false);
    const [audicion, setAudicion] = useState(dataAvance.antPatologicos.antpaDisminucionAudicionPa==="Si"?true:false);
    const [piel, setPiel] = useState(dataAvance.antPatologicos.antpaEnfPielPa==="Si"?true:false);
    const [pulmones, setPulmones] = useState(dataAvance.antPatologicos.antpaEnfPulmonesPa==="Si"?true:false);
    const [rin, setRin] = useState(dataAvance.antPatologicos.antpaEnfRinonesPa==="Si"?true:false);
    const [cor, setCor] = useState(dataAvance.antPatologicos.antpaEnfCorazonPa==="Si"?true:false);
    const [higado, setHigado] = useState(dataAvance.antPatologicos.antpaEnfHigadoPa==="Si"?true:false);
    const [fracturas, setFracturas] = useState(dataAvance.antPatologicos.antpaFracturasEsguincesAmputacionPa==="Si"?true:false);
    const [fuma, setFuma] = useState(dataAvance.antPatologicos.antpaFumaPa==="Si"?true:false);
    const [hip, setHip] = useState(dataAvance.antPatologicos.antpaHipertensionPa==="Si"?true:false);
    const [alcohol, setAlcohol] = useState(dataAvance.antPatologicos.antpaBebidasAlcoholicasPa==="Si"?true:false);
    const [varices, setVarices] = useState(dataAvance.antPatologicos.antpaVaricesPa==="Si"?true:false);

    //Segunda Parte
    const [sarampion, setSarampion] = useState(dataAvance.antPatologicos.antpaSarampionPa==="Si"?true:false);
    const [varicela, setVaricela] = useState(dataAvance.antPatologicos.antpaVaricelaPa==="Si"?true:false);
    const [rubeola, setRubeola] = useState(dataAvance.antPatologicos.antpaRubeolaPa==="Si"?true:false);
    const [herpes, setHerpes] = useState(dataAvance.antPatologicos.antpaHerpesPa==="Si"?true:false);
    const [paperas, setPaperas] = useState(dataAvance.antPatologicos.antpaParotiditisPa==="Si"?true:false);
    const [hepatitis, setHepatitis] = useState(dataAvance.antPatologicos.antpaHepatitisPa==="Si"?true:false);
    const [transfusiones, setTransfusiones] = useState(dataAvance.antPatologicos.antpaTransfusionesPa==="Si"?true:false);
    const [gastritis, setGastritis] = useState(dataAvance.antPatologicos.antpaGastritisPa==="Si"?true:false);
    const [colitis, setColitis] = useState(dataAvance.antPatologicos.antpaColitisPa==="Si"?true:false);
    const [hernias, setHernias] = useState(dataAvance.antPatologicos.antpaHerniasPa==="Si"?true:false);
    const [autoinmunes, setAutoinmunes] = useState(dataAvance.antPatologicos.antpaAutoinmunesPa==="Si"?true:false);
    const [movilidad, setMovilidad] = useState(dataAvance.antPatologicos.antpaLimitacionMovilidadPa==="Si"?true:false);
    const [nacimiento, setNacimiento] = useState(dataAvance.antPatologicos.antpaProblemasNacimientoPa==="Si"?true:false);
    const [medicamento, setMedicamento] = useState(dataAvance.antPatologicos.antpaConsumeMedicamentoPa==="Si"?true:false);
    const [depresion, setDepresion] = useState(dataAvance.antPatologicos.antpaDepresionAnsiedadPa==="Si"?true:false);
    const [terapia, setTerapia] = useState(dataAvance.antPatologicos.antpaTerapiaPa==="Si"?true:false);
    const [otras, setOtras] = useState(dataAvance.antPatologicos.antpaOtrasPa==="Si"?true:false);
    const [senas, setSenas] = useState(dataAvance.antPatologicos.antpaSeniasParticularesPa==="Si"?true:false);



    return (

        <Grid container spacing={1} p={1} style={{ backgroundColor:"#FFF" }}>
            {/*------------ Alergias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Alergias</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaAlergiasPa"
                            value={dataAvance.antPatologicos.antpaAlergiasPa}
                            // onChange={(e) => { setAlergias(!alergias); handleChangeClinicoMed(e) }}
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {alergias ?
                    <Slide direction="left" in={alergias} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaAlergiasPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaAlergiasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaAlergiasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Asma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Asma (silba el pecho)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaAsmaPa"
                            value={dataAvance.antPatologicos.antpaAsmaPa}
                            // onChange={(e) => { setAsm(!asm); handleChangeClinico(e) }}
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {asm ?
                    <Slide direction="left" in={asm} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="medicoTitulo"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaAsmaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaAsmaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Cancer --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Cáncer</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaCancerPa"
                            value={dataAvance.antPatologicos.antpaCancerPa}
                            onChange={(e) => { setCan(!can); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {can ?
                    <Slide direction="left" in={can} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaCancerPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaCancerPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaCancerPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Cirugias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Cirugías</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaCirugiasPa"
                            value={dataAvance.antPatologicos.antpaCancerPa}
                            onChange={(e) => { setCirugias(!cirugias); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {cirugias ?
                    <Slide direction="left" in={cirugias} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaCirugiasPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaCirugiasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaCirugiasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Convulsiones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Convulsiones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaConvulsionesPa"
                            value={dataAvance.antPatologicos.antpaConvulsionesPa}
                            onChange={(e) => { setConv(!conv); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {conv ?
                    <Slide direction="left" in={conv} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaConvulsionesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaConvulsionesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaConvulsionesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Desmayos --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Desmayos</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaDesmayosPa"
                            value={dataAvance.antPatologicos.antpaDesmayosPa}
                            onChange={(e) => { setDesmayos(!desmayos); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {desmayos ?
                    <Slide direction="left" in={desmayos} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDesmayosPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDesmayosPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDesmayosPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Diabetes--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Diabetes (azúcar elevada)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaDiabetesPa"
                            value={dataAvance.antPatologicos.antpaDiabetesPa}
                            onChange={(e) => { setDiab(!diab); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>

            <Grid item lg={7} sm={7} xs={12}>
                {diab ?
                    <Slide direction="left" in={diab} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDiabetesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDiabetesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDiabetesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Dolores --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}> Dolor constante de cuello o espalda baja</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaDolorEspaldaCuelloPa"
                            value={dataAvance.antPatologicos.antpaDolorEspaldaCuelloPa}
                            onChange={(e) => { setDolores(!dolores); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {dolores ?
                    <Slide direction="left" in={dolores} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDolorEspaldaCuelloPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDolorEspaldaCuelloPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDolorEspaldaCuelloPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Comunicacion--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Limitación en la comunicación oral y escrita</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaLimitacionOralEscritaPa"
                            value={dataAvance.antPatologicos.antpaLimitacionOralEscritaPa}
                            onChange={(e) => { setComunicacion(!comunicacion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>

            <Grid item lg={7} sm={7} xs={12}>
                {comunicacion ?
                    <Slide direction="left" in={comunicacion} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaLimitacionOralEscritaPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaLimitacionOralEscritaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaLimitacionOralEscritaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Vision --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Disminución de la visión</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaDisminucionVisualPa"
                            value={dataAvance.antPatologicos.antpaDisminucionVisualPa}
                            onChange={(e) => { setVision(!vision); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {vision ?
                    <Slide direction="left" in={vision} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDisminucionVisualPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDisminucionVisualPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDisminucionVisualPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Audicion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Disminución en audición </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaDisminucionAudicionPa"
                            value={dataAvance.antPatologicos.antpaDisminucionAudicionPa}
                            onChange={(e) => { setAudicion(!audicion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {audicion ?
                    <Slide direction="left" in={audicion} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDisminucionAudicionPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDisminucionAudicionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDisminucionAudicionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Piel --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De la piel</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="comentariosPatologicos,antpaEnfPielPa"
                            value={dataAvance.antPatologicos.antpaEnfPielPa}
                            onChange={(e) => { setPiel(!piel); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {piel ?
                    <Slide direction="left" in={piel} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaEnfPielPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaEnfPielPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaEnfPielPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Pulmones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De los pulmones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaEnfPulmonesPa"
                            value={dataAvance.antPatologicos.antpaEnfPulmonesPa}
                            // onChange={(e) => { setPulmones(!pulmones); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {pulmones ?
                    <Slide direction="left" in={pulmones} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaEnfPulmonesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaEnfPulmonesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaEnfPulmonesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Riñon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De los riñones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaEnfRinonesPa"
                            value={dataAvance.antPatologicos.antpaEnfRinonesPa}
                            // onChange={(e) => { setRin(!rin); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {rin ?
                    <Slide direction="left" in={rin} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaEnfRinonesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaEnfRinonesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaEnfRinonesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Corazon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades Del corazón</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                              name="comentariosPatologicos,antpaEnfCorazonPa"
                            value={dataAvance.antPatologicos.antpaEnfCorazonPa}
                            // onChange={(e) => { setCor(!cor); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {cor ?
                    <Slide direction="left" in={cor} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaEnfCorazonPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaEnfCorazonPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaEnfCorazonPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Higado --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades del hígado</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="comentariosPatologicos,antpaEnfHigadoPa"
                            value={dataAvance.antPatologicos.antpaEnfHigadoPa}
                            // onChange={(e) => { setHigado(!higado); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {higado ?
                    <Slide direction="left" in={higado} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaEnfHigadoPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaEnfHigadoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaEnfHigadoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Fracturas --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Fracturas, Esguinces o Amputación</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaFracturasEsguincesAmputacionPa"
                            value={dataAvance.antPatologicos.antpaFracturasEsguincesAmputacionPa}
                            // onChange={(e) => { setFracturas(!fracturas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {fracturas ?
                    <Slide direction="left" in={fracturas} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaFracturasEsguincesAmputacionPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaFracturasEsguincesAmputacionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaFracturasEsguincesAmputacionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Fuma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Fuma</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaFumaPa"
                            value={dataAvance.antPatologicos.antpaFumaPa}
                            // onChange={(e) => { setFuma(!fuma); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {fuma ?
                    <Slide direction="left" in={fuma} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaFumaPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaFumaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaFumaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Hipertensión (presión alta)--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hipertensión (presión alta)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaHipertensionPa"
                            value={dataAvance.antPatologicos.antpaHipertensionPa}
                            // onChange={(e) => { setHip(!hip); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hip ?
                    <Slide direction="left" in={hip} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaHipertensionPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaHipertensionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaHipertensionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Toma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Toma bebidas alcohólicas</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaBebidasAlcoholicasPa"
                            value={dataAvance.antPatologicos.antpaBebidasAlcoholicasPa}
                            // onChange={(e) => { setAlcohol(!alcohol); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {alcohol ?
                    <Slide direction="left" in={alcohol} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaBebidasAlcoholicasPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaBebidasAlcoholicasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaBebidasAlcoholicasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Varices --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Várices</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaVaricesPa"
                            value={dataAvance.antPatologicos.antpaVaricesPa}
                            // onChange={(e) => { setVarices(!varices); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {varices ?
                    <Slide direction="left" in={varices} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaVaricesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaVaricesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaVaricesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Sarampion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Sarampión</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaSarampionPa"
                            value={dataAvance.antPatologicos.antpaSarampionPa}
                            // onChange={(e) => { setSarampion(!sarampion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {sarampion ?
                    <Slide direction="left" in={sarampion} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaSarampionPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaSarampionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaSarampionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Varicela --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Varicela</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaVaricelaPa"
                            value={dataAvance.antPatologicos.antpaVaricelaPa}
                            // onChange={(e) => { setVaricela(!varicela); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {varicela ?
                    <Slide direction="left" in={varicela} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaVaricelaPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaVaricelaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaVaricelaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Rubeola --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Rubeóla</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaRubeolaPa"
                            value={dataAvance.antPatologicos.antpaRubeolaPa}
                            // onChange={(e) => { setRubeola(!rubeola); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {rubeola ?
                    <Slide direction="left" in={rubeola} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaRubeolaPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaRubeolaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaRubeolaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Herpes --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Herpes</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaHerpesPa"
                            value={dataAvance.antPatologicos.antpaHerpesPa}
                            // onChange={(e) => { setHerpes(!herpes); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {herpes ?
                    <Slide direction="left" in={herpes} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaHerpesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaHerpesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaHerpesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Paperas --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Parotiditis (paperas)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaParotiditisPa"
                            value={dataAvance.antPatologicos.antpaParotiditisPa}
                            // onChange={(e) => { setPaperas(!paperas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {paperas ?
                    <Slide direction="left" in={paperas} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaParotiditisPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaParotiditisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaParotiditisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Hepatitis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hepatitis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaHepatitisPa"
                            value={dataAvance.antPatologicos.antpaHepatitisPa}
                            // onChange={(e) => { setHepatitis(!hepatitis); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hepatitis ?
                    <Slide direction="left" in={hepatitis} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaHepatitisPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaHepatitisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaHepatitisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Transfusiones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Transfusiones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="comentariosPatologicos,antpaTransfusionesPa"
                            value={dataAvance.antPatologicos.antpaTransfusionesPa}
                            // onChange={(e) => { setTransfusiones(!transfusiones); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {transfusiones ?
                    <Slide direction="left" in={transfusiones} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaTransfusionesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaTransfusionesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaTransfusionesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Gastritis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Gastritis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaGastritisPa"
                            value={dataAvance.antPatologicos.antpaGastritisPa}
                            // onChange={(e) => { setGastritis(!gastritis) ; handleChangeClinico(e)}}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {gastritis ?
                    <Slide direction="left" in={gastritis} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaGastritisPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaGastritisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaGastritisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Colitis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Colitis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaColitisPa"
                            value={dataAvance.antPatologicos.antpaColitisPa}
                            // onChange={(e) => { setColitis(!colitis); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {colitis ?
                    <Slide direction="left" in={colitis} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaColitisPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaColitisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaColitisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------hernias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hernias</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaHerniasPa"
                            value={dataAvance.antPatologicos.antpaHerniasPa}
                            // onChange={(e) => { setHernias(!hernias); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hernias ?
                    <Slide direction="left" in={hernias} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaHerniasPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaHerniasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaHerniasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>

            {/*------------ Auto --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Autoinmunes</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaAutoinmunesPa"
                            value={dataAvance.antPatologicos.antpaAutoinmunesPa}
                            // onChange={(e) => { setAutoinmunes(!autoinmunes); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {autoinmunes ?
                    <Slide direction="left" in={autoinmunes} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaAutoinmunesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaAutoinmunesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaAutoinmunesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Limitacion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Limitación de movilidad </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaLimitacionMovilidadPa"
                            value={dataAvance.antPatologicos.antpaLimitacionMovilidadPa}
                            // onChange={(e) => { setMovilidad(!movilidad); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {movilidad ?
                    <Slide direction="left" in={movilidad} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaLimitacionMovilidadPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaLimitacionMovilidadPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaLimitacionMovilidadPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Problemas al nacimiento  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Problemas al nacimiento  </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaProblemasNacimientoPa"
                            value={dataAvance.antPatologicos.antpaProblemasNacimientoPa}
                            // onChange={(e) => { setNacimiento(!nacimiento); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {nacimiento ?
                    <Slide direction="left" in={nacimiento} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaProblemasNacimientoPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaProblemasNacimientoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaProblemasNacimientoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------medicamento  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Consume algún medicamento</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="comentariosPatologicos,antpaConsumeMedicamentoPa"
                            value={dataAvance.antPatologicos.antpaConsumeMedicamentoPa}
                            // onChange={(e) => { setMedicamento(!medicamento) ; handleChangeClinico(e)}}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {medicamento ?
                    <Slide direction="left" in={medicamento} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaConsumeMedicamentoPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaConsumeMedicamentoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaConsumeMedicamentoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Depresion  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Ha tenido depresión o ansiedad</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaDepresionAnsiedadPa"
                            value={dataAvance.antPatologicos.antpaDepresionAnsiedadPa}
                            // onChange={(e) => { setDepresion(!depresion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {depresion ?
                    <Slide direction="left" in={depresion} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaDepresionAnsiedadPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaDepresionAnsiedadPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaDepresionAnsiedadPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Terapia  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Ha recibido algún tipo de terapia</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaTerapiaPa"
                            value={dataAvance.antPatologicos.antpaTerapiaPa}
                            // onChange={(e) => { setTerapia(!terapia); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {terapia ?
                    <Slide direction="left" in={terapia} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaTerapiaPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaTerapiaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaTerapiaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
             {/*------------Otros  --------------- */}
             <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Otras</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="comentariosPatologicos,antpaOtrasPa"
                            value={dataAvance.antPatologicos.antpaOtrasPa}
                            // onChange={(e) => { setOtras(!otras); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {otras ?
                    <Slide direction="left" in={otras} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaOtrasPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaOtrasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaOtrasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Señas  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="Senas" style={{ marginRight: "10px", width: "30%" }}>Señas particulares </FormLabel>
                        <span id="Senas" style={{ fontSize: "0.6em", fontStyle: "italic" }}> (tatuajes, perforaciones, cicatrices o marcas de nacimiento)</span>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="Senas"
                           name="comentariosPatologicos,antpaSeniasParticularesPa"
                            value={dataAvance.antPatologicos.antpaSeniasParticularesPa}
                            // onChange={(e) => { setSenas(!senas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {senas ?
                    <Slide direction="left" in={senas} mountOnEnter unmountOnExit>
                        <TextField
                            style={{backgroundColor:"#FFF"}}
                            fullWidth
                            id="antpaSeniasParticularesPaCom"
                            label="Comentarios (solo por médico)"
                            name="comentariosPatologicos,antpaSeniasParticularesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={comentariosPatologicos.antpaSeniasParticularesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
        </Grid>
    )
}

export default Patologicos